import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export const CustomHelmet = ({ title, description }) => {
    const [showHelmet, setShowHelmet] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowHelmet(true);
        }, 200);

        return () => clearTimeout(timer);
    }, []);

    return showHelmet ? (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
        </Helmet>
    ) : null;
};
